/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renew': {
    width: 19,
    height: 16,
    viewBox: '0 0 19 16',
    data: '<path pid="0" d="M15.86 6.48l1.632-2.023.779.628-2.709 3.357-3.357-2.708.627-.778 2.034 1.64a6.523 6.523 0 1 0-.867 4.399l.854.52A7.521 7.521 0 1 1 15.86 6.48z" _fill="#FFF" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/renew.js